module.exports = __webpack_public_path__ + "static/media/artwork.7b0339b2.svg";